module.exports = __webpack_public_path__ + "static/img/modelBg.2df92f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modelBg.jpg
// module id = SRZO
// module chunks = 1